import {dayFormat, dateRangeHeaderFormat, agendaRangeHeaderFormat} from "../../utils/CalendarDateUtil";

export default {
    dateFormat: 'DD',
    dayFormat: dayFormat,
    monthHeaderFormat: 'MMMM, YYYY',
    dayRangeHeaderFormat: dateRangeHeaderFormat,
    dayHeaderFormat: 'dddd, MMMM DD, YYYY',
    agendaHeaderFormat: agendaRangeHeaderFormat
};